import { render, staticRenderFns } from "./feature_library_recommended.vue?vue&type=template&id=50e5f578"
import script from "./feature_library_recommended.vue?vue&type=script&lang=js"
export * from "./feature_library_recommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports